import axios from "axios";
import { ADD_CONTACT, CONVERSATIONS_EMPLOYEE_CONTACT_UPDATE } from "./type";
import { CONTACTS_TYPE } from "constants/contacts";
import { CONTACTS } from "endpointsConst";

const URL = CONTACTS;
export function addContacts(id) {
    return async (dispatch) => {
        try {
            await axios
                .post(URL, {
                    id,
                    type: CONTACTS_TYPE.FRIEND,
                })
                .then(({ data }) => {
                    dispatch({
                        type: ADD_CONTACT,
                        payload: data,
                    });
                    dispatch({
                        type: CONVERSATIONS_EMPLOYEE_CONTACT_UPDATE,
                        payload: data,
                    });
                });
        } catch (error) {
            // TODO handle error
        }
    };
}
